/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPrescription } from 'app/shared/model/prescription.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';
import { ITrimester } from 'app/shared/model/trimester.model';

export interface IPregnancyPrescription {
  id?: string;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  prescription?: IPrescription | null;
  labPrescription?: ILabPrescription | null;
  radiologyStudy?: IRadiologyStudy | null;
  trimester?: ITrimester | null;
}

export const defaultValue: Readonly<IPregnancyPrescription> = {
  active: false,
  draft: false,
};
